import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {ImageTrackingData} from '@aboutyou/tracking';
import {DeliveryWishlistButton} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {WishlistButton as WishlistButtonBase} from '../../../../features/Wishlist/WishlistButton';

export const WishlistButton: React.FC<{
  brand: Brand;
  product: Product;
  trackingData?: {
    sortingChannel?: string;
  };
  badgesListKeys: string[];
  getImageTrackingData?: () => ImageTrackingData | undefined;
}> = ({brand, product, trackingData, badgesListKeys, getImageTrackingData}) => {
  return (
    <Wrapper>
      <WishlistButtonBase
        product={product}
        brand={brand}
        WishlistComponent={DeliveryWishlistButton}
        trackingData={trackingData}
        badgesListKeys={badgesListKeys}
        getImageTrackingData={getImageTrackingData}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;
